<template>
  <section class="content box box-body">
    <div v-if="loading === 'after'" class="row">
      <div class="col-sm-12">
        <div class="box box-default box-solid">
          <div class="box-body table-responsive">
            <grid
              :content="incompleteTasks"
              :name="gridName"
              :columns="gridColumns"
              :actions="gridActions"
              :searchable="false"
              :server-side="false"
              @show="actionShow"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import ActionButton from '@/components/bundles/share/grid/ActionButton'
  import Grid from '../share/grid/Grid'
  import { mapState } from 'vuex'

  export default {
    name: 'IncompleteTaskListingComponent',
    components: { Grid },
    data () {
      return {
        events: {},
        gridDataSourceMethod: 'get',
        gridDataSource: {},
        gridName: 'grid_incomplete_task',
        service: this.$route.meta.acl.service,
        tabsData: []
      }
    },
    computed: {
      ...mapState({
        incompleteTasks: state => state.incompleteTasks.tasks,
        loading: state => state.incompleteTasks.loading
      }),
      gridColumns() {
        return [
          {
            id: 0,
            data: 'DT_RowId',
            searchable: false,
            orderable: false,
            render: (data, type, row) => {
              return ActionButton.renderActionButtons(data, type, row, this.gridActions, this)
            }
          },
          {
            id: 1,
            data: 'number',
            title: 'NR CRLS',
            searchable: false
          }
        ]
      },
      gridActions () {
        return [
          {
            id: 0,
            event: 'show',
            title: 'Szczegóły',
            icon: 'eye',
            params: ['taskId', 'parentId', 'client', 'workflow'],
            acl: {
              service: this.service,
              action: ['incomplete_tasks', 'get_incomplete_tasks'],
              allowOneOfServices: true,
              allowOneOfActions: true
            }
          }
        ]
      }
    },
    created () {
      this.getGridDataSource(this.service)
    },
    mounted () {
    },
    methods: {
      getGridDataSource (service) {
        this.gridDataSource = {
          service: 'intgen',
          url: `/tasks/incomplete`
        }
      },
      actionShow (id, params) {
        if (params) {
          let workflowMap = {
            'App\\Entity\\MainVehicleTask': 'main_vehicle',
            'App\\Entity\\MainPropertyTask': 'main_property',
            'App\\Entity\\MainPersonTask': 'main_person'
          }
          if (params.hasOwnProperty('client')) {
            return this.$router.push({
              name: `intbls_${params.client}_${workflowMap[params.workflow]}_appraisal_task_details`,
              params: { id: params.parentId, appraisalTaskId: id }
            })
          } else {
            return this.$router.push({
              name: `intgen_${workflowMap[params.workflow]}_appraisal_task_details`,
              params: { id: params.parentId, appraisalTaskId: id }
            })
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
